import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const GET_PROJECT_MEMBERSHIPS = gql`
  query ProjectMemberships($projectId: ID!) {
    projectMemberships(projectId: $projectId) {
      ...ProjectMembership
    }
  }
  ${fragments.projectMembership}
`

export const ADD_PROJECT_MEMBERSHIP = gql`
  mutation AddProjectMembership($projectId: ID!, $userId: String!) {
    acceptProjectInvitation(projectId: $projectId, userId: $userId) {
      ...ProjectMembership
    }
  }
  ${fragments.projectMembership}
`

export const JOIN_PROJECT_MEMBERSHIP = gql`
  mutation JoinProjectMembership($projectId: ID!) {
    joinProject(projectId: $projectId) {
      ...ProjectMembership
    }
  }
  ${fragments.projectMembership}
`

export const DELETE_FROM_GROUP_PROJECTS = gql`
  mutation DeleteFromGroupProjects($userId: String!) {
    deleteFromGroupProjects(userId: $userId)
  }
`

export const DELETE_PROJECT_MEMBERSHIP = gql`
  mutation DeleteProjectMembership($projectId: ID!, $userId: String!) {
    deleteProjectMembership(projectId: $projectId, userId: $userId)
  }
`

export const UPGRADE_TO_PREMIUM_PROJECT_MEMBERSHIP = gql`
  mutation UpgradeToPremiumMembership($projectId: ID!) {
    upgradeToPremiumMembership(projectId: $projectId) {
      ...ProjectMembership
    }
  }
  ${fragments.projectMembership}
`

export const EDIT_PROJECT_MEMBERSHIP = gql`
  mutation EditProjectMembership(
    $projectId: ID!
    $userId: String!
    $projectRole: ProjectRole!
    $defaultInvestorId: ID
  ) {
    editProjectMembership(
      projectId: $projectId
      userId: $userId
      projectRole: $projectRole
      defaultInvestorId: $defaultInvestorId
    ) {
      ...ProjectMembership
    }
  }
  ${fragments.projectMembership}
`

export const CHANGE_DEFAULT_INVESTOR = gql`
  mutation ChangeDefaultInvestor($projectId: ID!, $userId: String!, $defaultInvestorId: ID) {
    changeDefaultInvestor(
      projectId: $projectId
      userId: $userId
      defaultInvestorId: $defaultInvestorId
    ) {
      ...ProjectMembership
    }
  }
  ${fragments.projectMembership}
`

const mutations = {
  addRemote: ADD_PROJECT_MEMBERSHIP,
  saveRemote: EDIT_PROJECT_MEMBERSHIP,
  deleteRemote: DELETE_PROJECT_MEMBERSHIP,
  saveOp: 'editProjectMembership',
  addOp: 'acceptProjectInvitation',
  deleteOp: 'deleteProjectMembership',
}

export const projectMembershipQueries = { ...mutations, getRemote: GET_PROJECT_MEMBERSHIPS }
